import { render, staticRenderFns } from "./shipping-type-add.vue?vue&type=template&id=4cfdb037"
import script from "./shipping-type-add.vue?vue&type=script&lang=js"
export * from "./shipping-type-add.vue?vue&type=script&lang=js"
import style0 from "./shipping-type-add.vue?vue&type=style&index=0&id=4cfdb037&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports